import React from "react";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { string } from "prop-types";

import MODAL_VIEW_TYPES from "../../constants/modalViewTypes";
import { useStore, useUIStoreData } from "../../utilities/mobx/storeHooks";
import HomeClaimErrorView from "../HomeClaimErrorView";
import HomeClaimLoadingView from "../HomeClaimLoadingView";
import HomeClaimPersonalInfoForm from "../HomeClaimPersonalInfoForm";
import HomeClaimValidationForm from "../HomeClaimValidationForm";
import * as S from "./styled";

const ariaContentDescribedBy = "modal-content-description";
const ariaContentLabelledBy = "modal-content-label";

const HomeClaimModal = ({ className, rootElementId }) => {
  const { store } = useStore();
  const { uiStore } = store;
  const { isModalOpen, modalView } = useUIStoreData();

  const modalViews = {
    [MODAL_VIEW_TYPES.loading]: <HomeClaimLoadingView />,
    [MODAL_VIEW_TYPES.error]: (
      <HomeClaimErrorView handleClick={uiStore.closeModal} />
    ),
    [MODAL_VIEW_TYPES.personalInfo]: (
      <HomeClaimPersonalInfoForm
        ariaContentDescribedBy={ariaContentDescribedBy}
        ariaContentLabelledBy={ariaContentLabelledBy}
      />
    ),
    [MODAL_VIEW_TYPES.validation]: (
      <HomeClaimValidationForm
        ariaContentDescribedBy={ariaContentDescribedBy}
        ariaContentLabelledBy={ariaContentLabelledBy}
      />
    )
  };

  const ariaLabels = MODAL_VIEW_TYPES.loading
    ? null
    : {
        describedby: ariaContentDescribedBy,
        labelledby: ariaContentLabelledBy
      };

  return (
    <S.Modal
      aria={ariaLabels}
      className={className}
      isOpen={isModalOpen}
      onRequestClose={uiStore.closeModal}
      rootElementId={rootElementId}
    >
      <S.CloseButtonWrapper>
        <XButton onClick={uiStore.closeModal} />
      </S.CloseButtonWrapper>
      {modalViews[modalView]}
    </S.Modal>
  );
};

HomeClaimModal.propTypes = {
  className: string,
  rootElementId: string.isRequired
};

HomeClaimModal.defaultProps = {
  className: ""
};

export default HomeClaimModal;
